export default [
  {
    path: "/service-visit-comments",
    name: "service-visit-comments",
    component: () => import("@/modules/service-visit-comments/ServiceVisitComments.vue"),
    children: [
      {
        path: "list",
        name: "list-service-visit-comments",
        component: () => import("@/modules/service-visit-comments/pages/ServiceVisitCommentsList.vue"),
        meta: { permissions: ["transport-manager"] }
      },
      {
        path: "add",
        name: "add-service-visit-comments",
        component: () => import("@/modules/service-visit-comments/pages/ServiceVisitCommentsAdd.vue"),
        meta: { permissions: ["transport-manager"] }
      },
      {
        path: "edit/:id",
        name: "edit-service-visit-comments",
        component: () => import("@/modules/service-visit-comments/pages/ServiceVisitCommentsEdit.vue"),
        meta: { permissions: ["transport-manager"] }
      },
      {
        path: "show/:id",
        name: "show-service-visit-comments",
        component: () => import("@/modules/service-visit-comments/pages/ServiceVisitCommentsShow.vue"),
        meta: { permissions: ["transport-manager"] }
      }
    ]
  }
];
